import React from 'react';

export default function OptionButton({ index, label, icon, color, onClick }) {
  return (
    <button
      onClick={onClick}
      type="button"
      className={`option-btn ${index === 0 ? 'option-btn-primary' : 'option-btn-secondary'}`}
      style={{
        backgroundColor: color || undefined,
      }}
    >
      {icon && <span className="icon">{icon}</span>}
      <span className="option-label">{label}</span>
    </button>
  );
}
